import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-btn gfu-btn--narrow" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_copy_to_clipboard = _resolveComponent("copy-to-clipboard")

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_copy_to_clipboard, {
      "text-to-copy": $props.url,
      class: _normalizeClass(['gfu-icon', $options.getSizeClassName($props.size)]),
      "vertical-position": "down"
    }, null, 8 /* PROPS */, ["text-to-copy", "class"])
  ]))
}